import React from 'react'
import styles from './styles.css'
import vehicleTypesLabels from 'App/helpers/labels/vehicleTypesLabels'
import Time from './Time'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import moment from 'moment'
import numeral from 'numeral'
import VehicleTag from 'App/components/VehicleTag'
import TimeAgo from './TimeAgo'

export default function Shift(props) {
  const {shift} = props
  return (
    <a
      target="_blank"
      rel="noreferrer noopener"
      href={`/operator/shifts/${shift._id}`}
      className={styles.container}>
      {shift.reservedShift ? (
        <div className={styles.reservedContainer}>
          <div className={styles.reservedLabel}>{shift.reservedShift.name}</div>
        </div>
      ) : null}
      <div className={styles.head}>
        <div className={styles.type}>{vehicleTypesLabels[shift.vehicleType]}</div>
        <div className={styles.time}>
          <Tooltip content={`Desde ${moment(shift.startedAt).format('LLL')}`}>
            <Time shift={shift} />
          </Tooltip>
        </div>
      </div>
      <div className={styles.bottom}>
        <VehicleTag vehicle={shift.vehicle} />
        {shift.activeOrders.map(order => (
          <div className={styles.order} key={order._id}>
            <Tooltip content={order.description}>#{order.code}</Tooltip>
          </div>
        ))}
        {shift.location ? (
          <div className={styles.speed}>
            <Tooltip
              content={'Información de las ' + moment(shift.location.date).format('HH:mm:ss')}>
              {shift.location.speed === -1
                ? '0'
                : numeral(shift.location.speed * 3.6).format('0,0')}
              {' Km/h '}
              <TimeAgo shift={shift} />
            </Tooltip>
          </div>
        ) : (
          <div className={styles.noData}>No data</div>
        )}
      </div>
      {shift.deactivatedUntil && moment(shift.deactivatedUntil).isAfter(moment()) ? (
        <div>Desactivado hasta las {moment(shift.deactivatedUntil).format('HH:mm')}</div>
      ) : (
        ''
      )}
    </a>
  )
}
